export default (response) => {
  const blob = new Blob([response.data], {type: response.data.type})
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url

  let filename = ''
  const disposition = response.headers['content-disposition']

  const filenameRegex = /.*filename=['"]?([^"]+)/
  const matches = filenameRegex.exec(disposition)

  if (matches != null && matches[1]) {
    filename = matches[1].replace(/['"]/g, '')
  }

  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}



// WEBPACK FOOTER //
// ./src/utils/BlobDownload.js